import { Button } from "V2.0/common/button";

import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "V2.0/HomePages/PipelinesV2/PipelineBuilderV2/Components/ConfigurationPanel";
import NodeExecutionStatusBadge from "../../Components/NodeExecutionStatus";
import { formatTime } from "V2.0/utils";
import PreviewJson from "../../Components/PreviewJson";

export default WebhookTriggerExecution;

function getWebhookNodeInputAndOutput(nodeExecution) {
  if (!nodeExecution.input || !nodeExecution.output) {
    return {
      input: null,
      output: null,
    };
  }

  const { _webhookPayload: input } = nodeExecution.input;
  const { _webhookPayload, _webhookReceivedAt, ...rest } =
    nodeExecution.output.payload;

  return {
    input,
    output: { ...rest },
  };
}

function WebhookTriggerExecution(props) {
  const { node, nodeExecution, closePanel } = props;

  const { input, output } = getWebhookNodeInputAndOutput(nodeExecution);

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>{node.data.name}</p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <div className="space-y-4">
          <div className="flex items-center gap-x-2">
            <p className="text-sm">Status:</p>
            <NodeExecutionStatusBadge status={nodeExecution.status} />
          </div>
          {nodeExecution.startTime && (
            <div className="flex items-center gap-x-2">
              <p className="text-sm">Start Time:</p>
              <p className="text-sm">{formatTime(nodeExecution.startTime)}</p>
            </div>
          )}
          {nodeExecution.endTime && (
            <div className="flex items-center gap-x-2">
              <p className="text-sm">End Time:</p>
              <p className="text-sm">{formatTime(nodeExecution.endTime)}</p>
            </div>
          )}
          {input && (
            <PreviewJson
              data={input}
              title="Input"
            />
          )}
          {output && (
            <PreviewJson
              data={output}
              title="Output"
            />
          )}
        </div>
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end gap-x-2 items-center">
          <Button
            outline
            onClick={closePanel}
          >
            Close
          </Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
